import { render, staticRenderFns } from "./AamsEnterpriseRegApproval.vue?vue&type=template&id=a4b7edda&scoped=true&"
import script from "./AamsEnterpriseRegApproval.vue?vue&type=script&lang=js&"
export * from "./AamsEnterpriseRegApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b7edda",
  null
  
)

export default component.exports